import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection.js';
import HealthPerceptionChart from '../common/charts/HealthPerceptionChart.js';
import Methodology from '../common/Methodology.js';

const HealthComparedPeers = props => {

    useEffect(() =>{
        // Update the title of the page
		document.title = props.literals.L20919 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
    }, [])
    
    const chart = {
        type: 'osh-pulse',
        chart: '20029',
        chartIndicator: '581',
        answers: ['128','129','130','131','127','132']
    }
    return(
        <div className="health-compared-peers">
            <AdviceSection literals={ props.literals } section={["accidents-diseases-well-being","health-compared-peers"]} methodologyData={{section: 'accidents-diseases-well-being', subsection: 'Workers’ health compared to peers', indicator: 57}} />
            
            <div class="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
                <div class="card--block--chart">
                    <HealthPerceptionChart 
                        title={ props.literals[`L20922`] }
                        indicator= { chart.chartIndicator }
                        chart = { chart.chart }
                        colors={ ['#f6a400','#cbe2e3','#7b7b7d','#ffe300','#449fa2','#f3c564','#16983e'] }
                        answers={ chart.answers }
                        showDataFor={ 'country' }
                        stacked= { true }
                        yAxisMax = { 100 }
                        percentage = { true }
                        step = { 25 }
                    />
                </div>
                <div className="chart-legend">
                    {ReactHtmlParser( props.literals[`L20923`]) }
                </div>
            </div>
            

            <Methodology literals={ props.literals } section={ 'Workers’ health compared to peers' } indicator={581} />            
        </div>
    )
}
HealthComparedPeers.displayName = 'HealthComparedPeers';
export default HealthComparedPeers;